import React, {useEffect, useState} from 'react'
import PersonalitiesAPI from '../../api/personalityAPI';
import Label from '../roundedLabel';
import { useDispatch, useSelector } from "react-redux";
import {addFilterValue, deleteFilterValue} from '../../actions/filterActions';

export default function Personalities(props) {

    let [personalities, setPersonalities] = useState([]);

    let filteredPersonalities = useSelector(state => state.filters.selected.filter((filter) => filter.type === 'personality'));
    let initialFilters = useSelector(state => state.filters.initialFilters['personalities']);

    const dispatch = useDispatch();

    useEffect(
        () => {
            PersonalitiesAPI.getCollection().then((collection) => {
               setPersonalities(collection);
            }).catch(error => {
                  console.log(error);
             });
        }, []
    );

    useEffect(
        () => {
            if (personalities.length === 0 || !initialFilters) { return; }
            initialFilters.map((filter) => {
                let item = personalities.find(personality => personality.id === parseInt(filter));
                if (item) {
                    dispatch(addFilterValue(item, 'personality'))
                }
            });
        }, [personalities, initialFilters]
    );


    return(
        <div className="grid-x grid-padding-x mar-top-10 mar-bot-10 filters__options">
            {personalities.map((item) => {
                return <Label key={item.id} option={item}
                              hasImage={true}
                              add={() => dispatch(addFilterValue(item, 'personality'))}
                              delete={() => dispatch(deleteFilterValue(item, 'personality'))}
                              selected={!!filteredPersonalities.find((ind) => ind.id === item.id)} />
            })}
        </div>
    )

}